import { render } from "./phoneCheck.vue?vue&type=template&id=78cb6c18&scoped=true"
import script from "./phoneCheck.vue?vue&type=script&lang=js"
export * from "./phoneCheck.vue?vue&type=script&lang=js"

import "./phoneCheck.vue?vue&type=style&index=0&id=78cb6c18&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78cb6c18"]])

export default __exports__